import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

export const fetchWorkoutHistory = async ({ clientId, coachId }) => {
  const params = {
    clientId: clientId,
    coachId: coachId,
  };
  try {
    const response = await axiosInstance.get(
      `${Endpoints.GET_WORKOUT_HISTORY}`,
      {
        params,
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.data || "Failed to fetch workout history");
  }
};
